/**
  * Useful for post ajax calls, will fade-in message and auto fade-out by default.
  *
  * @param {String} message Text content for your alert bubble message.
  * @param {Number} [delay=2500] (Optional) In milliseconds the lag before message disappears.
  * @param {String} [element=body] (Optional) Selector for element where alert bubble gets attached.
  * @param {'roaming'|'fixed'} [type=fixed] (Optional) Change how you want to position the alert bubble by adding class called 'roaming'.
  *
  * @example
  *   alertBubble("your message here");
  *   alertBubble("your message here", 0, '.your_desired_element', 'roaming');
  */
function alertBubble(message, delay = 2500, element = 'body', type = 'fixed') {
  const lazyLoad = async () => {
    await import('@static/css/zr/zr.alert_bubble.less');
  };

  lazyLoad();

  const disappearDelay = (delay === 0) ? 0 : delay;
  const $document = $(document);
  let $bubble = $('.alert_bubble');
  const $close = $('<button type="button" class="close_message trigger-close_message">Close</button>');

  const destroyOldBubble = () => {
    $bubble.remove();
  };

  const createNewBubble = () => {
    $bubble = $(`<div class="alert_bubble toast_message">${message}</div>`).appendTo(element);
    if (disappearDelay === 0) {
      $bubble
        .addClass('linger')
        .append($close);
    }
  };

  // Assemble the message.
  if (!$bubble.length) {
    createNewBubble();
  } else if (element !== 'body') {
    destroyOldBubble();
    createNewBubble();
  } else {
    $bubble.html(message);
  }

  // set the type
  if (type === 'roaming') {
    $bubble.addClass('roaming');
  }

  // Show element, which needs the 0 to allow transition, then add class
  $bubble.show(0).addClass('showing');

  if (disappearDelay === 0) {
    // Don't remove alert bubble automatically
  } else {
    setTimeout(() => {
      $bubble.removeClass('showing');
    }, disappearDelay);
  }

  // listen to close alert bubble
  $document.on('click', '.toast_message .trigger-close_message', () => {
    $bubble.removeClass('showing');
  });
}

export default alertBubble;
